import { render, staticRenderFns } from "./renderer-page.vue?vue&type=template&id=0342816a&scoped=true&"
import script from "./renderer-page.vue?vue&type=script&lang=js&"
export * from "./renderer-page.vue?vue&type=script&lang=js&"
import style0 from "./renderer-page.vue?vue&type=style&index=0&id=0342816a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342816a",
  null
  
)

export default component.exports